import React from "react";
import { default as TotalWorkingHours } from "components/Dashboard/Dashboard_TotalWorkingHours"
import { WIDGET_NAMES } from "components/WidgetTemplates/utils";
import { useTranslation } from "react-i18next";

const Card_TotalWorkingHours = (props) => {
	// console.log(props);
	const { t } = useTranslation();

	return (
		<article className="card card-resumen">
			<div className="card-top">
				<h2>{t(WIDGET_NAMES[props.name])}</h2>
			</div>
			<div className="card-content">
				<TotalWorkingHours />
			</div>
		</article>
	);
};

export default Card_TotalWorkingHours;